import React from "react"

import { WorkData } from "./data/WorkData.js"
import { CodeProjectData } from "./data/CodeProjectData.js"

import Background from "../img/code-bg.png"
import MobileBackground from "../img/mobile-code bg.png"
import Overlay from "../img/overlay.png"

import "./style/Programming.css"

import Nav from "../components/Navigation"
import Footer from "../components/Footer.js"

const Programming = () => {
    function gridder(data) {
        var allWorks = data,
            workList = [],
            works = []
        for (var i = 0; i < allWorks.length; i++) {
            if (i % 3 === 0 && i !== 0) {
                works.push(workList)
                workList = []
            }
            workList.push(allWorks[i])
        }
        works.push(workList)
        return works
    }
    function gridderTwo(data) {
        var allWorks = data,
            workList = [],
            works = []
        for (var i = 0; i < allWorks.length; i++) {
            if (i % 2 === 0 && i !== 0) {
                works.push(workList)
                workList = []
            }
            workList.push(allWorks[i])
        }
        works.push(workList)
        return works
    }

    return (
        <div>
            <div className="foundation">
                <Nav className="nav" />
                <img src={Background} alt="background" className="code-background" />
                <img
                    src={MobileBackground}
                    alt="background"
                    className="mobile-code-background"
                />
                <div className="prog-footer">
                    <Footer />
                </div>
            </div>
            <div className="content">
                <div className="body">
                    <p>
                        After coming to Berkeley, I was introduced to the wonderful
                        world of computer science and the potential it gives me to
                        build and create. I now spend much of my time building web
                        applications on both the front and back end.
                    </p>
                    <p>
                        However, the journey wasn’t easy, especially at Cal. So I
                        have also dedicated a lot of my time to teaching CS and
                        building communities where people can comfortably and happily
                        learn.
                    </p>
                </div>
                <div className="portfolio">
                    <div className="work">
                        <h2 className="work-title">WORK AND FREELANCE</h2>
                        <div className="img-grid">
                            <div className="row">
                                {gridder(WorkData)[0].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <div className="overlay">
                                                <img
                                                    src={Overlay}
                                                    className="blackbox"
                                                    alt="overlay"
                                                />
                                                <p
                                                    className="description"
                                                    style={{ zIndex: 3 }}
                                                >
                                                    {work.description}
                                                </p>
                                            </div>
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="row">
                                {gridder(WorkData)[1].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <div className="overlay">
                                                <img
                                                    src={Overlay}
                                                    className="blackbox"
                                                    alt="overlay"
                                                />
                                                <p
                                                    className="description"
                                                    style={{ zIndex: 3 }}
                                                >
                                                    {work.description}
                                                </p>
                                            </div>
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(WorkData)[0].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(WorkData)[1].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(WorkData)[2].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="projects">
                        <h2 className="work-title">PROJECTS AND PASSIONS</h2>
                        <div className="img-grid">
                            <div className="row">
                                {gridder(CodeProjectData)[0].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <div className="overlay">
                                                <img
                                                    src={Overlay}
                                                    className="blackbox"
                                                    alt="overlay"
                                                />
                                                <p
                                                    className="description"
                                                    style={{ zIndex: 3 }}
                                                >
                                                    {work.description}
                                                </p>
                                            </div>
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="row">
                                {gridder(CodeProjectData)[1].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <div className="overlay">
                                                <img
                                                    src={Overlay}
                                                    className="blackbox"
                                                    alt="overlay"
                                                />
                                                <p
                                                    className="description"
                                                    style={{ zIndex: 3 }}
                                                >
                                                    {work.description}
                                                </p>
                                            </div>
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(CodeProjectData)[0].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(CodeProjectData)[1].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            <div className="mobile-row">
                                {gridderTwo(CodeProjectData)[2].map((work) => {
                                    return (
                                        <a
                                            href={work.link}
                                            className="wrapper"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={work.image}
                                                className="image"
                                                alt="logo"
                                            ></img>
                                        </a>
                                    )
                                })}
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Programming
